module.exports = __webpack_public_path__ + "img/dashboard_sale_mono_icon.024c3ad1.svg";